<template>
    <va-edit-layout>
        <DebtRecoveryEventChargeInstrument-form
            :id="id"
            :title="title"
            :item="item"
        ></DebtRecoveryEventChargeInstrument-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
